export * from '@mui/material/colors';
// customize color
export const coolGrey = {
    100: '#FAFAFC',
    200: '#F3F4F8',
    300: '#E8EAEF',
    400: '#D7DBE5',
    500: '#BCC0CB',
    600: '#9197AA',
    700: '#6E758F',
    800: '#5B6178',
    900: '#444A5E',
    1000: '#1D2631',
};
export const warmGrey = {
    100: '#FAFAFA',
    200: '#F6F7F9',
    300: '#EEEEEE',
    400: '#DDDDDD',
    500: '#BDBDBD',
    600: '#AAAAAA',
    700: '#888888',
    800: '#666666',
    900: '#444444',
    1000: '#222222',
};
/** B2C */
export const b2c = {
    100: '#F2F8FF',
    200: '#E2F2FF',
    300: '#B0D9FB',
    400: '#64B5F6',
    500: '#2196F3',
    600: '#0B74E2',
    700: '#0F61D0',
    800: '#1242B1',
};
/** B2B */
export const b2b = {
    100: '#F5F1FF',
    200: '#EEE6FF',
    300: '#B79EFF',
    400: '#A17FFF',
    500: '#8A61FC',
    600: '#7241F9',
    700: '#6036D4',
    800: '#4521A6',
};
